import { useQuery } from '@tanstack/react-query';
import * as clinicsApi from '../../apis/clinics/requests';

export const useClinics = () => {
  const { data: clinicsResponse, isFetched: isLoaded, refetch } = useQuery({
    queryKey: ['clinics'],
    queryFn: () => clinicsApi.getClinics(0, 50),
    meta: { errorMessage: 'Failed to load clinics list' }
  });

  const total = clinicsResponse?.pagination?.total ?? 0;
  const clinics = clinicsResponse?.data || [];

  return {
    clinics,
    isLoaded,
    total,
    refetch
  };
};
